<template>
    <div class="index">
        <div class="index_title">
            <div class="realTop">
                <span @click="showIndex">返回首页</span>
                <span style="font-size: 35px">
                    <img src="../../assets/img/bigData/联合 29.png" />
                    {{ this.$store.state.orgName }}养老一张图</span
                >
                <span @click="showFullScreen">{{
                    onFullScreen ? "退出全屏" : "进入全屏"
                }}</span>
            </div>
            <!--      头部数据栏-->
            <div class="index_hear">
                <!--        左侧数据栏-->
                <div class="index_hear_left">
                    <div class="XiaoShou">
                        <img
                            src="../../assets/img/bigData/index_hear_left1.png"
                            alt=""
                            srcset=""
                        />
                        全区常住人口
                        <div class="numG">
                            {{
                                demographicData.residentPopulation
                                    ? demographicData.residentPopulation
                                    : 0
                            }}
                        </div>
                    </div>
                    <div class="XiaoShou">
                        <img
                            src="../../assets/img/bigData/index_hear_left2.png"
                            alt=""
                            srcset=""
                        />
                        全区户籍人口
                        <div class="numO">
                            {{
                                demographicData.registeredPopulation
                                    ? demographicData.registeredPopulation
                                    : 0
                            }}
                        </div>
                    </div>
                </div>
                <!--        中部数据栏-->
                <div class="index_hear_mid">
                    <div class="XiaoShou">
                        <div class="numP">
                            {{
                                demographicData.sixtyToSixtynine
                                    ? demographicData.sixtyToSixtynine
                                    : 0
                            }}
                        </div>
                        <div>60-69岁(人)</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numZ">
                            {{
                                demographicData.seventyToSeventynine
                                    ? demographicData.seventyToSeventynine
                                    : 0
                            }}
                        </div>
                        <div>70-79岁(人)</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numB">
                            {{
                                demographicData.eightyToEightynine
                                    ? demographicData.eightyToEightynine
                                    : 0
                            }}
                        </div>
                        <div>80-89岁(人)</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numG">
                            {{
                                demographicData.ninetyToNinetynine
                                    ? demographicData.ninetyToNinetynine
                                    : 0
                            }}
                        </div>
                        <div>90-99岁(人)</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numO">
                            {{
                                demographicData.centenarian
                                    ? demographicData.centenarian
                                    : 0
                            }}
                        </div>
                        <div>100岁以上(人)</div>
                    </div>
                </div>
                <!--        右侧数据栏-->
                <div class="index_hear_right">
                    <div class="XiaoShou">
                        <div class="numP">
                            {{
                                demographicData.difficultOldPeople
                                    ? demographicData.difficultOldPeople
                                    : 0
                            }}
                        </div>
                        <div>特困老人</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numZ">
                            {{
                                demographicData.poorOldPeople
                                    ? demographicData.poorOldPeople
                                    : 0
                            }}
                        </div>
                        <div>低保老人</div>
                    </div>
                    <div class="XiaoShou">
                        <div class="numB">
                            {{
                                demographicData.disabilityAllowance
                                    ? demographicData.disabilityAllowance
                                    : 0
                            }}
                        </div>
                        <div>两残补贴</div>
                    </div>
                </div>
            </div>
            <!--  地图模块-->
            <div class="index_Map">
                <div class="index_MapBody">
                    <div id="Map"></div>
                    <div class="el_button" @click="showSheQU"></div>
                    <div class="index_Map_title" v-if="SheQuButton">
                        <span>{{ treeData[0].label }}</span>
                        <img
                            src="../../assets/img/bigData/index_Map_close.png"
                            alt=""
                            @click="showSheQU"
                        />
                        <div class="index_Map_Hear">
                            <el-tree
                                :data="treeData"
                                :props="defaultProps"
                                accordion
                                @node-click="handleNodeClick"
                            >
                            </el-tree>
                        </div>
                    </div>
                </div>
            </div>
            <!--      区域老年人数量模块-->
            <div class="index_body_top">
                <div>区域老年人数量</div>
                <div id="oldNums"></div>
            </div>
            <!--      养老趋势模块-->
            <div class="index_body_left">
                <div>自理类型</div>
                <div id="main"></div>
            </div>
            <!--      养老资源模块-->
            <div class="index_body_right">
                <div>养老资源</div>
                <div class="index_body_rBox">
                    <div class="index_body_rBoxOne">
                        <span></span>
                        <span class="index_body_rBoxOneSpan">
                            <div>8</div>
                            <div>居家养老</div>
                        </span>
                    </div>
                    <div class="index_body_rBoxTwo">
                        <span></span>
                        <span class="index_body_rBoxOneSpan">
                            <div>8</div>
                            <div>适老化</div>
                        </span>
                    </div>
                    <div class="index_body_rBoxThree">
                        <span></span>
                        <span class="index_body_rBoxOneSpan">
                            <div>8</div>
                            <div>社区养老</div>
                        </span>
                    </div>
                    <div class="index_body_rBoxFever">
                        <span></span>
                        <span class="index_body_rBoxOneSpan">
                            <div>8</div>
                            <div>家庭床位</div>
                        </span>
                    </div>
                    <div class="index_body_rBoxSix">
                        <span></span>
                        <span class="index_body_rBoxOneSpan">
                            <div>8</div>
                            <div>机构养老</div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="oldManBox">
            <el-dialog title="老人信息" :visible.sync="oldManBox">
                <div class="oldManBox_Title">基本信息</div>
                <el-row>
                    <el-col :span="4" class="oldManBoxHear">
                        <img
                            class="img1"
                            src="../../assets/img/bigData/蒙版组 121.png"
                            alt=""
                        />
                        <img
                            class="img2"
                            src="../../assets/img/bigData/老人信息类型.png"
                            alt=""
                        />
                        <div>低保期限：2022-6-28</div>
                    </el-col>
                    <el-col :span="20">
                        <el-form :model="oldManList">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item
                                        label="老人姓名："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="年龄："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="性别："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item
                                        label="手机号码："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item
                                        label="老人地址："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item
                                        label="监护人："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="联系方式："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="与老人关系："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item
                                        label="紧急联系人："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="紧急联系方式："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item
                                        label="与老人关系："
                                        :label-width="formLabelWidth"
                                    >
                                        <el-input
                                            v-model="oldManList.name"
                                            autocomplete="off"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
                <div class="oldManBox_Title">保障信息</div>
                <el-tabs v-model="activeName" type="card">
                    <el-tab-pane label="3月" name="first">
                        <el-table
                            :data="oldManData"
                            class="table-style"
                            border
                            :header-row-style="getRowClass7"
                            :header-cell-style="getRowClass7"
                            :row-style="getRowClass"
                            style="width: 100%"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                type="index"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="creatTime"
                                label="创建日期"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="name"
                                label="服务项目"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="sTime"
                                label="开始时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="eTime"
                                label="结束时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="type"
                                label="状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.type == 0"
                                        style="color: #ff0038"
                                        >未开始</span
                                    >
                                    <span
                                        v-if="scope.row.type == 1"
                                        style="color: #00bc7f"
                                        >进行中</span
                                    >
                                    <span
                                        v-if="scope.row.type == 2"
                                        style="color: #cceef5"
                                        >已结束</span
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="2月" name="second">
                        <el-table
                            :data="oldManData"
                            class="table-style"
                            border
                            :header-row-style="getRowClass7"
                            :header-cell-style="getRowClass7"
                            :row-style="getRowClass"
                            style="width: 100%"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                type="index"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="creatTime"
                                label="创建日期"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="name"
                                label="服务项目"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="sTime"
                                label="开始时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="eTime"
                                label="结束时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="type"
                                label="状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.type == 0"
                                        style="color: #ff0038"
                                        >未开始</span
                                    >
                                    <span
                                        v-if="scope.row.type == 1"
                                        style="color: #00bc7f"
                                        >进行中</span
                                    >
                                    <span
                                        v-if="scope.row.type == 2"
                                        style="color: #cceef5"
                                        >已结束</span
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="1月" name="third">
                        <el-table
                            :data="oldManData"
                            class="table-style"
                            border
                            :header-row-style="getRowClass7"
                            :header-cell-style="getRowClass7"
                            :row-style="getRowClass"
                            style="width: 100%"
                        >
                            <el-table-column
                                align="center"
                                label="序号"
                                type="index"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="creatTime"
                                label="创建日期"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="name"
                                label="服务项目"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="sTime"
                                label="开始时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="eTime"
                                label="结束时间"
                            >
                            </el-table-column>
                            <el-table-column
                                align="center"
                                prop="type"
                                label="状态"
                            >
                                <template slot-scope="scope">
                                    <span
                                        v-if="scope.row.type == 0"
                                        style="color: #ff0038"
                                        >未开始</span
                                    >
                                    <span
                                        v-if="scope.row.type == 1"
                                        style="color: #00bc7f"
                                        >进行中</span
                                    >
                                    <span
                                        v-if="scope.row.type == 2"
                                        style="color: #cceef5"
                                        >已结束</span
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts"
export default {
    computed: {},
    data() {
        return {
            activeName: "first",
            formLabelWidth: "120px",
            oldManList: {},
            oldManData: [
                {
                    creatTime: "2022-03-20",
                    name: "衣物清洗",
                    sTime: "2022-03-21 00:00:00",
                    eTime: "2022-03-21 24:00:00",
                    type: "0",
                },
                {
                    creatTime: "2022-03-15",
                    name: "衣物清洗",
                    sTime: "2022-03-16 00:00:00",
                    eTime: "2022-03-17 24:00:00",
                    type: "1",
                },
                {
                    creatTime: "2022-03-03",
                    name: "衣物清洗",
                    sTime: "2022-03-05 00:00:00",
                    eTime: "2022-03-06 24:00:00",
                    type: "2",
                },
            ],
            oldManBox: false,
            SheQuButton: false,
            onFullScreen: false,
            map: null,
            marker: [],
            treeData: [],
            demographicData: {},
            stationData: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
        }
    },
    mounted() {
        // this.getTreeselectList()
        // this.getDemographictList()
        // this.getStationList()
        console.log(this.$store.state)
        this.$nextTick(() => {
            this.showditu()
            this.main()
            this.oldNumss()
        })
    },
    methods: {
        getRowClass7({ row, column, rowIndex, columnIndex }) {
            return "background:#2B73A9;color:#fff;border-right:1px solid #68C3FC;border-bottom:1px solid #68C3FC"
        },
        getRowClass({ row, column, rowIndex, columnIndex }) {},
        // getTreeselectList() {
        //     this.$http
        //         .request({
        //             url: "/system/dept/treeselect1",
        //             method: "GET",
        //         })
        //         .then((res) => {
        //             if (res.code == 200) {
        //                 this.treeData = res.data
        //             } else {
        //                 this.$message.error(res.msg)
        //             }
        //         })
        // },
        // getDemographictList() {
        //     this.$http
        //         .request({
        //             url: "/dsj/config/demographic/list",
        //             method: "POST",
        //             data: {},
        //         })
        //         .then((res) => {
        //             if (res.code == 200) {
        //                 this.demographicData = res.data
        //             } else {
        //                 this.$message.error(res.msg)
        //             }
        //         })
        // },
        // getStationList() {
        //     this.$http
        //         .request({
        //             url: "/dsj/config/mzDemographic/list",
        //             method: "POST",
        //             data: {},
        //         })
        //         .then((res) => {
        //             if (res.code == 200) {
        //                 this.stationData = res.data
        //                 this.$nextTick(() => {
        //                     this.oldNumss()
        //                 })
        //             } else {
        //                 this.$message.error(res.msg)
        //             }
        //         })
        // },
        handleNodeClick(data) {
            console.log(data)
        },
        showSheQU() {
            this.SheQuButton = !this.SheQuButton
        },
        //机构养老点击跳转
        homeOrgage() {
            this.$router.push("homeOrgage")
        },
        //社区养老点击跳转
        homeComage() {
            this.$router.push("homeComage")
        },
        //居家养老点击跳转
        homeOldage() {
            this.$router.push("homeOldage")
        },
        //家庭床位点击跳转
        homeBedage() {
            this.$router.push("homeBedage")
        },
        //地图打点
        getManage(data) {
            let biao = require("../../assets/img/bigData/maker.png")
            // let biao = ""
            if (this.marker) {
                this.map.remove(this.marker)
                this.marker = []
            }
            let addressLng = "117.193083"
            let addressLat = "31.823373"
            if (addressLng && addressLat) {
                let marker = new AMap.Marker({
                    position: [Number(addressLng), Number(addressLat)],
                    icon: new AMap.Icon({
                        image: biao,
                        size: new AMap.Size(40, 50), //图标大小
                        imageSize: new AMap.Size(40, 50),
                    }),
                })
                var text = new AMap.Text({
                    position: [Number(addressLng), Number(addressLat)],
                    text: "张",
                    anchor: "center", // 设置文本标记锚点
                    draggable: true,
                    cursor: "pointer",
                    // angle:10,
                    style: {
                        width: "20px",
                        height: "22px",
                        "line-height": "22px",
                        "font-size": "14px",
                        "text-align": "center",
                        color: "#42B1E2",
                        border: "none",
                        background: "none",
                        margin: "-16px 0 0 22px",
                        // 'background':'url("../assets/bigData/空白打点.png") 0 0 no-repeat',
                        // 'background-size':'100% 100%',
                    },
                })
                marker.on("click", (e) => {
                    //点击地图打的点
                    this.oldManBox = true
                    console.log(e)
                })
                text.on("click", (e) => {
                    this.oldManBox = true
                    console.log(e)
                })
                this.marker.push(marker)
            }
            this.map.add(this.marker)
            text.setMap(this.map)
        },
        //显示地图
        async showditu() {
            this.map = new AMap.Map("Map", {
                zoom: 13,
                zooms: [3, 20],
                center: [117.193083, 31.823373],
                mapStyle: "amap://styles/darkblue",
                // showLabel: false,
            })
            this.getManage()
        },
        // 返回首页
        showIndex() {
            this.$router.push("index")
        },
        // 控制全屏展示
        showFullScreen() {
            this.onFullScreen = !this.onFullScreen
            if (this.onFullScreen) {
                var docElm = document.documentElement
                if (docElm.requestFullscreen) {
                    docElm.requestFullscreen()
                } else if (docElm.msRequestFullscreen) {
                    docElm = document.body //overwrite the element (for IE)
                    docElm.msRequestFullscreen()
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen()
                } else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
            }
        },

        async main() {
            var chartDom = document.getElementById("main")
            var myChart = echarts.init(chartDom)
            var option

            option = {
                tooltip: {
                    // trigger: 'axis'
                },
                color: ["#FF7043", "#02C4E0"],
                legend: {
                    data: ["性别比例", "居住类型统计"],
                    top: 20,
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                },
                grid: {
                    left: "5%",
                    right: "5%",
                    bottom: "5%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: ["", "2021", "2022", "2023", "2024", "2025", ""],
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                    splitLine: {
                        //修改背景线条样式
                        show: true, //是否展示
                        lineStyle: {
                            color: "#6A7E9A", //线条颜色
                            type: "dashed", //线条样式，默认是实现，dashed是虚线
                        },
                    },
                },
                series: [
                    {
                        name: "性别比例",
                        type: "line",
                        // stack: 'Total',
                        data: ["", 182, 191, 234, 290, 330, ""],
                        smooth: true,
                    },
                    {
                        name: "居住类型统计",
                        type: "line",
                        // stack: 'Total',
                        data: ["", 132, 101, 134, 90, 230, ""],
                        smooth: true,
                    },
                ],
            }

            option && myChart.setOption(option)
        },

        async oldNumss() {
            console.log(this.stationData)
            var chartDom = document.getElementById("oldNums")
            var myChart = echarts.init(chartDom)
            var option

            let xAxisData = [
                "沙坪坝社区",
                "第二社区",
                "第三社区",
                "第四社区",
                "第五社区",
                "第六社区",
                "第七社区",
            ]
            let data1 = ["50", "20", "43", "55", "63", "34", "2"]
            let data2 = ["18", "63", "34", "2", "20", "43", "55"]
            // this.stationData.forEach((item)=>{
            //   console.log(item)
            //   if(item){
            //     xAxisData.push(item.name)?xAxisData.push(item.name):'暂无名称'
            //     data1.push(item.men )?data1.push(item.men ):'0'
            //     data2.push(item.women)?data2.push(item.women):'0'
            //   }else{
            //     xAxisData.push('暂无名称')
            //     data1.push('0')
            //     data2.push('0')
            //   }
            //
            // })
            // for (let i = 0; i < 15; i++) {
            // xAxisData.push('社区');
            // data1.push(+(Math.random() * 9).toFixed(0));
            // data2.push(+(Math.random() * 9).toFixed(0));
            // }
            var emphasisStyle = {
                itemStyle: {
                    shadowBlur: 2,
                    shadowColor: "rgba(0,0,0,0.3)",
                    color: "#fff",
                },
            }
            option = {
                legend: {
                    data: [, "男", "女"],
                    left: "80%",
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                color: ["#00BC7F", "#FB7391"],
                xAxis: {
                    data: xAxisData,
                    name: "X Axis",
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                    splitLine: { show: false },
                    splitArea: { show: false },
                    axisLabel: {
                        //坐标轴刻度标签的相关设置。
                        interval: 0,
                        rotate: 30,
                        formatter: function (params) {
                            var maxLength = 4
                            //判断长度，超出使用...代替
                            if (params && params.length > maxLength) {
                                return (
                                    params.substring(0, maxLength - 1) + "..."
                                )
                            } else {
                                return params
                            }
                        },
                    },
                },
                yAxis: {
                    axisLine: {
                        lineStyle: {
                            type: "solid",
                            color: "#fff", //左边线的颜色
                            width: "1", //坐标线的宽度
                        },
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                series: [
                    {
                        name: "男",
                        type: "bar",
                        stack: "one",
                        barWidth: 20,
                        emphasis: emphasisStyle,
                        data: data1,
                    },
                    {
                        name: "女",
                        type: "bar",
                        stack: "one",
                        barWidth: 20,
                        emphasis: emphasisStyle,
                        data: data2,
                    },
                ],
            }
            // myChart.on("brushSelected", function (params) {
            //     var brushed = []
            //     var brushComponent = params.batch[0]
            //     for (
            //         var sIdx = 0;
            //         sIdx < brushComponent.selected.length;
            //         sIdx++
            //     ) {
            //         var rawIndices = brushComponent.selected[sIdx].dataIndex
            //         brushed.push(
            //             "[Series " + sIdx + "] " + rawIndices.join(", ")
            //         )
            //     }
            //     myChart.setOption({
            //         title: {
            //             backgroundColor: "#333",
            //             text: "SELECTED DATA INDICES: \n" + brushed.join("\n"),
            //             bottom: 0,
            //             right: "10%",
            //             width: 100,
            //             textStyle: {
            //                 fontSize: 12,
            //                 color: "#fff",
            //             },
            //         },
            //     })
            // })

            option && myChart.setOption(option)
        },
        // 老年人口数量
        async oldNums() {
            console.log(this.sexList, "aaaaaaaaaaaaa")
            const myChart = this.$echarts.init(
                document.getElementById("oldNums")
            )
            var option
            var mData = []
            var fData = []
            var xData = []
            var totalData = []
            var allnumber = []

            this.sexList.forEach((item) => {
                mData.push(item.male)
                fData.push(item.female)
                xData.push(item.address)
                allnumber.push(item.number)
            })

            for (let i = 0; i < mData.length; i++) {
                let total = Number(mData[i]) + Number(fData[i])
                totalData.push(total)
            }
            option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                color: ["#0F5BF5", "#F21B62"],
                legend: {
                    icon: "circle",
                    data: ["男", "女"],
                    right: "0",
                    top: "20",
                    textStyle: {
                        fontSize: 12,
                        color: "#fff",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        data: xData,
                        axisLabel: {
                            interval: 0,
                            rotate: 65,
                        },
                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#fff", //左边线的颜色
                                width: "1", //坐标线的宽度
                            },
                        },
                        axisTick: {
                            alignWithLabel: true,
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#fff", //左边线的颜色
                                width: "1", //坐标线的宽度
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "男",
                        type: "bar",
                        stack: "人数",
                        emphasis: {
                            focus: "series",
                        },
                        barWidth: 20,
                        data: mData,
                        barGap: "0",
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                distance: -24,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                    {
                        name: "女",
                        type: "bar",
                        stack: "人数",
                        emphasis: {
                            focus: "series",
                        },
                        data: fData,
                        barGap: "0",
                        barWidth: 20,
                        label: {
                            normal: {
                                show: true,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                distance: -24,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                    },
                    {
                        //新的一个柱子 注意不设stack
                        name: "总数",
                        type: "bar",
                        barGap: "0%", // 左移100%，stack不再与上面两个在一列
                        barWidth: 9,
                        label: {
                            normal: {
                                show: true,
                                barWidth: 0,
                                formatter: "{c}",
                                align: "center",
                                verticalAlign: "middle",
                                rotate: 90,
                                position: "top",
                                color: "rgba(128, 128, 128, 0)",
                                background: "rgba(128, 128, 128, 0),",
                                distance: 25,
                                left: "-30",
                                textStyle: {
                                    color: "#fff",
                                    fontSize: 14,
                                },
                            },
                        },
                        data: this.targetId ? allnumber : totalData,
                    },
                ],
            }
            option && myChart.setOption(option)
        },
    },
}
</script>

<style lang="less" scoped>
.XiaoShou {
    cursor: pointer;
}
.numG {
    color: #00bc7f;
    font-size: 26px;
}
.numO {
    color: #ff7044;
    font-size: 26px;
}
.numP {
    color: #fb7391;
    font-size: 26px;
}
.numZ {
    color: #c56afa;
    font-size: 26px;
}
.numB {
    color: #02c4e0;
    font-size: 26px;
}
.index {
    position: relative;
    color: #ffffff;
    width: 100%;
    height: 100%;
    background-color: #000000;
    padding: 0.5%;
    .index_title {
        width: 100%;
        height: 100%;
        // background: url("/assets/bigData/顶部标题.png") 0 0 no-repeat;
        background-size: 100% 100%;
        .realTop {
            // background: url("/assetsg/bigData/顶部按钮.png") 0 0 no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            width: auto;
            height: 40px;
            position: relative;
            top: 15px;
            padding: 0 16.5%;
            img {
                height: 30px;
            }
            :nth-child(1) {
                cursor: pointer;
                margin-top: 10px;
            }
            :nth-child(2) {
                margin-top: -18px;
            }
            :nth-child(3) {
                cursor: pointer;
                margin-top: 10px;
            }
        }
        .index_hear {
            position: absolute;
            top: 10%;
            left: 1%;
            width: 98%;
            height: 12%;
            display: flex;
            justify-content: space-between;
            .index_hear_left {
                width: 25%;
                height: 100%;
                background: url("../../assets/img/bigData/index_hear_left.png")
                    0 0 no-repeat;
                background-size: 100% 100%;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                padding: 0 2.5%;
                align-items: center;
                > div {
                    width: 40%;
                    text-align: center;
                }
                img {
                    width: 14px;
                    height: 14px;
                    margin-right: 10%;
                }
            }
            .index_hear_mid {
                width: 49%;
                height: 100%;
                background: url("../../assets/img/bigData/index_hear_mid.png") 0
                    0 no-repeat;
                background-size: 100% 100%;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                padding: 0 2.5%;
                align-items: center;
                > div {
                    text-align: center;
                }
            }
            .index_hear_right {
                width: 25%;
                height: 100%;
                background: url("../../assets/img/bigData/index_hear_left.png")
                    0 0 no-repeat;
                background-size: 100% 100%;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                padding: 0 2.5%;
                align-items: center;
                > div {
                    text-align: center;
                }
            }
        }
        .index_Map {
            position: absolute;
            bottom: 2%;
            left: 1%;
            width: 48%;
            height: 75%;
            background: url("../../assets/img/bigData/index_Map.png") 0 0
                no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            .index_MapBody {
                width: 100%;
                height: 100%;
                position: relative;
                #Map {
                    margin: 0.5% auto;
                    border-radius: 30px;
                    width: 99%;
                    height: 99%;
                }
                .el_button {
                    cursor: pointer;
                    background: url("../../assets/img/bigData/图形结合-left.png")
                        0 0 no-repeat;
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    top: 6%;
                    left: 3%;
                    padding: 8px 20px;
                    color: #bbe9fe;
                    font-size: 20px;
                    z-index: 1;
                }
                .index_Map_title {
                    position: absolute;
                    top: 6.5%;
                    left: 9%;
                    width: 220px;
                    height: 60px;
                    background: url("../../assets/img/bigData/形状结合-right.png")
                        0 0 no-repeat;
                    text-align: center;
                    span {
                        line-height: 50px;
                    }
                    img {
                        cursor: pointer;
                        position: relative;
                        left: 30px;
                    }
                    .index_Map_Hear {
                        .el-tree {
                            position: relative;
                            //left: 20%;
                            background: linear-gradient(
                                180deg,
                                rgba(104, 195, 252, 0.5) 0%,
                                rgba(104, 195, 252, 0.15) 100%
                            );
                            color: #ffffff;
                            width: 95%;
                        }
                    }
                }
            }
        }
        .index_body_top {
            background: url("../../assets/img/bigData/index_body_top.png") 0 0
                no-repeat;
            background-size: 100% 100%;
            width: 49%;
            height: 37%;
            position: absolute;
            bottom: 40%;
            right: 1%;
            overflow: hidden;
            :nth-child(1) {
                text-align: center;
                padding-top: 10px;
                color: #bbe9fe;
                font-size: 20px;
            }
            #oldNums {
                width: 100%;
                height: 85%;
            }
        }
        .index_body_left {
            background: url("../../assets/img/bigData/index_body_left.png") 0 0
                no-repeat;
            background-size: 100% 100%;
            width: 24%;
            height: 37%;
            position: absolute;
            bottom: 2%;
            right: 26%;
            overflow: hidden;
            > :nth-child(1) {
                text-align: center;
                padding-top: 10px;
                color: #bbe9fe;
                font-size: 20px;
            }
            .index_body_leftBox {
                width: 100%;
                height: 15%;
                display: flex;
                justify-content: space-between;
                padding: 3% 5%;
                > div {
                    text-align: center;
                    > :nth-child(1) {
                        font-size: 24px;
                    }
                    > :nth-child(2) {
                        color: #ffffff;
                        font-size: 12px;
                    }
                }
            }
            #main {
                width: 100%;
                height: 90%;
            }
        }
        .index_body_right {
            background: url("../../assets/img/bigData/index_body_left.png") 0 0
                no-repeat;
            background-size: 100% 100%;
            width: 24%;
            height: 37%;
            position: absolute;
            bottom: 2%;
            right: 1%;
            :nth-child(1) {
                text-align: center;
                padding-top: 10px;
                color: #bbe9fe;
                font-size: 20px;
            }
            .index_body_rBox {
                height: 85%;
                width: 100%;
                padding: 3% 5% 0 5%;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                > div {
                    cursor: pointer;
                    background: url("../../assets/img/bigData/index_body_rightBG.png")
                        0 0 no-repeat;
                    background-size: 100% 100%;
                    width: 49%;
                    height: 30%;
                    display: flex;
                    > :nth-child(1) {
                        width: 50%;
                        height: 100%;
                    }
                    .index_body_rBoxOneSpan {
                        :nth-child(1) {
                            font-size: 20px;
                            color: #ffffff;
                        }
                        :nth-child(2) {
                            font-size: 14px;
                            color: #ffffff;
                        }
                    }
                }
                > div:hover {
                    background: url("../../assets/img/bigData/index_body_rightBG2.png")
                        0 0 no-repeat;
                    background-size: 100% 100%;
                    .index_body_rBoxOneSpan {
                        :nth-child(1) {
                            color: #ff7044;
                        }
                        :nth-child(2) {
                            color: #ff7044;
                        }
                    }
                }
                .index_body_rBoxOne {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rONE1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxOne:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rONE2.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxTwo {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rTwo1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxTwo:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rTwo2.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxThree {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rThree1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxThree:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rThree2.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxFour {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rFour1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxFour:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rFour2.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxFever {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rFever1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxFever:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rFever2.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxSix {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rSix1.png")
                            50% 40% no-repeat;
                    }
                }
                .index_body_rBoxSix:hover {
                    > :nth-child(1) {
                        background: url("../../assets/img/bigData/index_body_rSix2.png")
                            50% 40% no-repeat;
                    }
                }
            }
        }
    }
}
.oldManBox {
    ::v-deep .el-dialog {
        background-color: #044770;
        border: 1px solid #68c3fc;
        .el-dialog__header {
            background-color: #158bd4;
        }
        .el-dialog__title {
            color: white;
            color: #bbe9fe;
            caret-color: transparent;
        }

        .el-icon-close {
            color: white;

            &:hover {
                color: rgb(9, 205, 219);
            }
        }
        .el-form-item__label {
            color: #ffffff;
        }
        .el-dialog__body {
            color: #ffffff;
            font-size: 18px;
        }
    }
    /deep/.el-input__inner {
        color: #bbe9fe;
        background-color: #044770 !important;
        border: 1px solid #68c3fc;
    }
    .oldManBox_Title {
        height: 44px;
        width: 211px;
        background: url("../../assets/img/bigData/老人信息2.png") 0 0 no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 44px;
        font-size: 20px;
        margin: 0 0 20px -20px;
    }
    .oldManBoxHear {
        text-align: center;
        .img1 {
            width: 150px;
            height: 150px;
        }
        .img2 {
            width: 32px;
            height: 32px;
        }
        div {
            font-size: 12px;
        }
    }
}
.table-style {
    margin-top: 10px;
    //border: 1px solid #68C3FC;
    .has-gutter th {
        background-color: #082d4e;
        color: #80e6ff;
        height: auto !important;
    }
    .el-table__row:nth-child(odd) {
        background-color: transparent;
    }
    /deep/.el-table__row {
        background-color: #044770;
        > td {
            > div {
                color: #bbe9fe;
            }
        }
    }
    /deep/.el-table__row:hover {
        background-color: #044770;
    }
    .el-table__row:nth-child(even) {
        background-color: yellow;
    }
    /deep/.el-table__body td {
        color: #fff;
        height: auto !important;
    }
}

//树形图图标更换
::v-deep .el-icon-caret-right:before {
    content: "\e723";
    font-size: 16px;
}
::v-deep .expanded:before {
    content: "\e722";
    font-size: 16px;
}
::v-deep .el-tree-node__expand-icon.expanded {
    transform: none;
}
//树形图选中信息背景色
/deep/.el-tree-node:focus > .el-tree-node__content {
    background-color: rgba(104, 195, 252, 0.4);
}
//树形图悬浮信息背景色
/deep/.el-tree-node__content:hover {
    background-color: rgba(104, 195, 252, 0.4);
}

/deep/.el-table--border,
.el-table--group {
    border-color: #68c3fc;
}
/deep/.el-table td,
.el-table th.is-leaf {
    border-bottom: 1px solid #68c3fc;
}
/deep/.el-table--border th,
.el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #68c3fc;
}
/deep/.el-table--border td,
.el-table--border th {
    border-right: 1px solid #68c3fc;
}

/deep/.el-table tbody tr:hover > td {
    background-color: transparent !important;
}

/deep/.el-tabs__nav-wrap::after {
    background-color: transparent !important;
}
/deep/.el-tabs__active-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 70px;
    background-color: transparent;
    z-index: 1;
}
/deep/.el-tabs__header.is-top {
    border: none;
}
/deep/.el-tabs__nav.is-top {
    border: none;
}
/deep/.el-tabs__item.is-top {
    margin-left: 10px;
    border: 1px solid #68c3fc !important;
    border-radius: 5px;
    color: #bbe9fe;
}
/deep/.el-tabs__item.is-active {
    color: #fff;
    font-weight: bold;
    background-color: #68c3fc;
    border: 1px solid #68c3fc !important;
}
</style>
